import React, { type ForwardedRef, type PropsWithChildren } from "react";
import CardVariant, { type CardVariants } from "./Card.styles";

export type CardVariantsType = keyof typeof CardVariants;

type CardVariantType = {
    variant: CardVariantsType;
    cardRef?: ForwardedRef<HTMLDivElement>;
    role?: React.AriaRole;
};

const Card: React.FC<PropsWithChildren<CardVariantType>> = (props) => {
    const { cardRef, variant, role, children, ...rest } = props;
    return (
        <CardVariant ref={cardRef} variant={variant} role={role} {...rest}>
            {children}
        </CardVariant>
    );
};

export default Card;
